import { render, staticRenderFns } from "./addRetail.vue?vue&type=template&id=40f732ef&scoped=true"
import script from "./addRetail.vue?vue&type=script&lang=js"
export * from "./addRetail.vue?vue&type=script&lang=js"
import style0 from "./addRetail.vue?vue&type=style&index=0&id=40f732ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f732ef",
  null
  
)

export default component.exports